import { render, staticRenderFns } from "./ElementOrderKpiTableColumn.vue?vue&type=template&id=08433bed"
import script from "./ElementOrderKpiTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementOrderKpiTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports